import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { EMPTY, Observable, of } from 'rxjs';

import { selectProfileByType } from '@era/stores';
import { Store } from '@ngrx/store';
import { PanelComponent } from '@rocksoft/cdk';
import { DeviceInformation } from '@rocksoft/mdm-sdk-v2';
import { ErrorModel } from '@rocksoft/shared';

import { OSSupportedPipe } from '../../../pipes/os-supported.pipe';
import { ManagedSettingsAppanalyticsContainerComponent } from '../../../sub-features/device-settings/managed-settings/app-analytics/app-analytics.container';
import { ManagedSettingsBluetoothContainerComponent } from '../../../sub-features/device-settings/managed-settings/bluetooth/bluetooth.container';
import { ManagedSettingsDataRoamingContainerComponent } from '../../../sub-features/device-settings/managed-settings/data-roaming/data-roaming.container';
import { ManagedSettingsDeviceNameContainerComponent } from '../../../sub-features/device-settings/managed-settings/device-name/device-name.container';
import { ManagedSettingsDiagnosticSubmissionContainerComponent } from '../../../sub-features/device-settings/managed-settings/diagnostic-submission/diagnostic-submission.container';
import { ManagedSettingsHostNameContainerComponent } from '../../../sub-features/device-settings/managed-settings/host-name/host-name.container';
import { ManagedSettingsMaximumResidentUsersContainerComponent } from '../../../sub-features/device-settings/managed-settings/maximum-resident-users/maximum-resident-users.container';
import { ManagedSettingsMdmOptionsContainerComponent } from '../../../sub-features/device-settings/managed-settings/mdm-options/mdm-options.container';
import { ManagedSettingsPassCodeLockGracePeriodContainerComponent } from '../../../sub-features/device-settings/managed-settings/passcode-lock-grace-period/pass-code-lock-grace-period.container';
import { ManagedSettingsPersonalHotspotContainerComponent } from '../../../sub-features/device-settings/managed-settings/personal-hotspot/personal-hotspot.container';
import { SetWallpaperContainerComponent } from '../../../sub-features/device-settings/managed-settings/set-wallpaper/set-wallpaper.container';
import { ManagedSettingsVoiceRoamingContainerComponent } from '../../../sub-features/device-settings/managed-settings/voice-roaming/voice-roaming.container';
import { WifiPresetInstallContainerComponent } from '../wifi-preset-install/wifi-preset-install.container';

@Component({
  selector: 'ml-mdm-apple-device-settings',
  templateUrl: './apple-device-settings.container.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    PanelComponent,
    WifiPresetInstallContainerComponent,
    SetWallpaperContainerComponent,
    ManagedSettingsDeviceNameContainerComponent,
    ManagedSettingsBluetoothContainerComponent,
    ManagedSettingsHostNameContainerComponent,
    ManagedSettingsDataRoamingContainerComponent,
    ManagedSettingsVoiceRoamingContainerComponent,
    ManagedSettingsPersonalHotspotContainerComponent,
    ManagedSettingsMdmOptionsContainerComponent,
    ManagedSettingsPassCodeLockGracePeriodContainerComponent,
    ManagedSettingsMaximumResidentUsersContainerComponent,
    ManagedSettingsDiagnosticSubmissionContainerComponent,
    ManagedSettingsAppanalyticsContainerComponent,
    OSSupportedPipe,
  ],
})
export class AppleDeviceSettingsContainerComponent {
  private readonly store = inject(Store);

  public readonly apple = this.store.selectSignal(selectProfileByType('device-information'));
  public error: ErrorModel;

  handleError(error: ErrorModel): Observable<DeviceInformation | null> {
    if (error.status && error.status === 404) {
      // TODO Log as error
      return of<DeviceInformation | null>(null);
    }
    this.error = error;
    return EMPTY;
  }
}
